module.exports = __webpack_public_path__ + "img/gold@2x.589637c.jpg";